export const getTileUrl = (cityName) =>
  cityName?.includes?.("iran")
    ? process.env.REACT_APP_API_TILE_URL_IRAN
    : process.env.REACT_APP_API_TILE_URL;
